import styled from "styled-components";

export const AuthContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100vw;
    min-height: 100vh;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 400;
    background-color: #fafaf7;
    color: #1a1d12;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const ImageBackground = styled.img`
    width: 100%;
`

export const AuthSideInfo = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 58%;
    min-height: 100vh;
    padding: 60px;
    background-color: #14180b;
    background-image:
        linear-gradient(135deg, rgba(20, 24, 11, 0.55) 0%, rgba(20, 24, 11, 0.85) 100%),
        url('https://api.praysely.com/prys/lp-church.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(50% 40% at 20% 80%, rgba(111, 149, 46, 0.35) 0%, transparent 70%);
        pointer-events: none;
    }

    @media (max-width: 768px) {
        width: 100%;
        min-height: 280px;
        padding: 32px;
    }
`

export const InfoContainer = styled.div`
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 540px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
    padding: 36px;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    color: #f5f5f0;
    line-height: 1.7;
    font-size: 17px;
    box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.08) inset,
        0 30px 60px rgba(0, 0, 0, 0.35);

    span {
        color: rgba(245, 245, 240, 0.82);
        font-weight: 400;
        letter-spacing: -0.005em;
    }

    @media (max-width: 768px) {
        padding: 24px;
        font-size: 15px;
    }
`

export const ICTITLE = styled.div`
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #c9d4a8;
    margin-bottom: 16px;

    @media (max-width: 768px) {
        font-size: 12px;
        margin-bottom: 10px;
    }
`

export const AuthSideForm = styled.div`
    width: 42%;
    min-height: 100vh;
    background-color: #fafaf7;
    display: flex;
    align-items: stretch;
    justify-content: center;

    @media (max-width: 768px) {
        width: 100%;
    }
`

export const FormContainer = styled.div`
    width: 100%;
    max-width: 480px;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 48px 40px;
    align-items: flex-start;
    justify-content: space-between;
    gap: 32px;

    @media (max-width: 768px) {
        padding: 32px 24px;
    }
`

export const LoginHeader = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    cursor: pointer;

    img {
        height: 36px !important;
        width: auto !important;
        object-fit: contain;
    }
`

export const FormMain = styled.div`
    width: 100%;
    flex: 1;
`

export const FormMainHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 28px;

    h1 {
        font-size: 28px;
        font-weight: 700;
        letter-spacing: -0.025em;
        color: #1a1d12;
        margin: 0 0 6px;
        line-height: 1.2;
    }

    p {
        font-size: 14px;
        color: #6b6f5d;
        margin: 0;
        letter-spacing: -0.005em;
    }
`

export const InputItemWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 18px;
`

export const InputLabel = styled.label`
    font-size: 13px;
    font-weight: 500;
    color: #4a4f3d;
    margin-bottom: 8px;
    letter-spacing: -0.005em;
`

export const InputFieldItem = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1.5px solid ${props => props.isError ? '#d04848' : '#e4e6dc'};
    background-color: #ffffff;
    border-radius: 14px;
    transition: border-color 0.18s ease, box-shadow 0.18s ease;
    overflow: hidden;

    &:focus-within {
        border-color: ${props => props.isError ? '#d04848' : '#6f952e'};
        box-shadow: 0 0 0 4px ${props => props.isError ? 'rgba(208, 72, 72, 0.12)' : 'rgba(111, 149, 46, 0.14)'};
    }

    input {
        width: 100%;
        padding: 16px 18px;
        border-radius: 14px;
        outline: none;
        border: none;
        background: transparent;
        font-size: 15px;
        font-family: inherit;
        color: #1a1d12;
        letter-spacing: -0.005em;

        &::placeholder {
            color: #a3a896;
        }
    }
`

export const AuthButton = styled.button`
    width: 100%;
    padding: 16px;
    border-radius: 14px;
    background: linear-gradient(135deg, #8cb83a 0%, #6f952e 100%);
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    letter-spacing: -0.01em;
    border: none;
    cursor: pointer;
    margin-top: 8px;
    box-shadow:
        0 1px 0 rgba(255, 255, 255, 0.18) inset,
        0 8px 20px rgba(111, 149, 46, 0.28),
        0 1px 3px rgba(0, 0, 0, 0.15);
    transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        box-shadow:
            0 1px 0 rgba(255, 255, 255, 0.22) inset,
            0 12px 26px rgba(111, 149, 46, 0.38),
            0 2px 6px rgba(0, 0, 0, 0.18);
    }

    &:active:not(:disabled) {
        transform: translateY(0);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
`

export const ForgotPasswordButton = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin: 4px 0 16px;
    font-size: 13px;
    color: #6b6f5d;
    cursor: pointer;

    span {
        color: #6f952e;
        font-weight: 500;
        transition: color 0.18s ease;

        &:hover {
            color: #4a6b1c;
        }
    }
`

export const DHA = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #6b6f5d;
    margin-top: 24px;
    gap: 6px;

    p {
        color: #6f952e;
        font-weight: 600;
        cursor: pointer;
        margin: 0;
        text-decoration: none;
        transition: color 0.18s ease;

        &:hover {
            color: #4a6b1c;
            text-decoration: underline;
        }
    }
`

export const LoginFooter = styled.div`
    font-size: 12px;
    color: #9a9d8b;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 0.02em;
`

export const TabSelectWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 24px;
`

export const UserTypeTabSelect = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    margin-top: 4px;
    gap: 12px;
`

export const TabItem = styled.div`
    position: relative;
    width: 50%;
    aspect-ratio: 1 / 0.85;
    color: ${props => props.selected ? '#3a4e15' : '#6b6f5d'};
    font-size: 14px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    gap: 10px;
    background: ${props => props.selected ? 'rgba(111, 149, 46, 0.08)' : '#ffffff'};
    border: 1.5px solid ${props => props.selected ? '#6f952e' : '#e4e6dc'};
    border-radius: 18px;
    transition: all 0.2s ease;

    svg {
        color: ${props => props.selected ? '#6f952e' : '#8a8e7a'};
        transition: color 0.2s ease;
    }

    &:hover {
        border-color: ${props => props.selected ? '#6f952e' : '#c9cdba'};
        background: ${props => props.selected ? 'rgba(111, 149, 46, 0.1)' : '#fbfbf8'};
    }
`

export const CheckWrapper = styled.div`
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: absolute;
    top: -8px;
    right: -8px;
    background: linear-gradient(135deg, #8cb83a 0%, #6f952e 100%);
    box-shadow: 0 4px 10px rgba(111, 149, 46, 0.4);

    svg {
        color: white;
        width: 12px;
        height: 12px;
        font-size: 12px;
    }
`
